import styled from 'styled-components';

const Promotions = styled.div`
  overflow: hidden;
  background-color: #eee;

  .slick-slider {
    margin-top: 1em;
    margin-bottom: 1em;
    height: 15em;

    .slick-list {
      margin: 0;
    }

    .slick-slide img {
      margin: 0 auto;
    }

    .slick-slide {
      padding-left: 1em;
      padding-right: 1em;
    }
  }
`;

export default Promotions;
